"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocketNetworkListener = void 0;
const DomainEvents_1 = require("../utils/DomainEvents");
const Observable_1 = require("./Observable");
class SocketNetworkListener {
    constructor(organizationId) {
        this.organizationId = organizationId;
    }
    onAuthenticated(socketId) {
        Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getEventKey)(DomainEvents_1.SocketNetworkEvents.ON_AUTHENTICATE_SUCCEEDED, this.organizationId), { socketId });
    }
    onPong() {
        Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getEventKey)(DomainEvents_1.SocketNetworkEvents.ON_PONG, this.organizationId), {});
    }
    onConnect() {
        Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getEventKey)(DomainEvents_1.SocketNetworkEvents.ON_CONNECT, this.organizationId), {});
    }
    onDisconnect(socketId) {
        Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getEventKey)(DomainEvents_1.SocketNetworkEvents.ON_DISCONNECT, this.organizationId), { socketId });
    }
    onReconnectAttempt(attemptNumber) {
        Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getEventKey)(DomainEvents_1.SocketNetworkEvents.ON_RECONNECT_ATTEMPT, this.organizationId), { attemptNumber });
    }
    onReconnectFailed() {
        Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getEventKey)(DomainEvents_1.SocketNetworkEvents.ON_RECONNECT_FAILED, this.organizationId), {});
    }
}
exports.SocketNetworkListener = SocketNetworkListener;
